// extracted by mini-css-extract-plugin
export default {"navbar":"SideBar_navbar__cM08K","logoWrapperMobile":"SideBar_logoWrapperMobile__Ej6wT","mobileHidden":"SideBar_mobileHidden__uASq2","desktopHidden":"SideBar_desktopHidden__6vu1k"};